import { UserClaims } from "../types/users";
import { AuthFilterAll, AuthFilterOwn } from "./auth-filter";
import { getRules } from "./constants";

// We define general types of users - so we don't need to get too granular on claims
const rules = getRules();

export const AdminUserClaims: UserClaims[] = [
  rules.sayHello.createClaim(AuthFilterAll),
  rules.isUser.createClaim(AuthFilterAll),
  rules.isViewer.createClaim(AuthFilterAll),
  rules.maintainProfiles.createClaim(AuthFilterAll),
  rules.isAdmin.createClaim(AuthFilterAll),
  rules.bundleMaint.createClaim(AuthFilterAll),
  rules.isTester.createClaim(AuthFilterAll),
  rules.reports.createClaim(AuthFilterAll),
  rules.canPrint.createClaim(AuthFilterAll),
];

export const MaintainUserClaims: UserClaims[] = [
  rules.sayHello.createClaim(AuthFilterAll),
  rules.isViewer.createClaim(AuthFilterOwn),
  rules.isUser.createClaim(AuthFilterOwn),
  rules.maintainProfiles.createClaim(AuthFilterAll),
];

export const NormalUserClaims: UserClaims[] = [
  rules.sayHello.createClaim(AuthFilterAll),
  rules.isViewer.createClaim(AuthFilterOwn),
  rules.isUser.createClaim(AuthFilterOwn),
  rules.maintainProfiles.createClaim(AuthFilterOwn),
];

export const ServiceUserClaims: UserClaims[] = [rules.sayHello.createClaim(AuthFilterAll)];

export const ServiceUserCiCdClaims: UserClaims[] = [...ServiceUserClaims, rules.bundleMaint.createClaim(AuthFilterAll)];

export const TestClaim: UserClaims[] = [rules.isTester.createClaim(AuthFilterAll)];

export const CanPrintClaim: UserClaims[] = [rules.canPrint.createClaim(AuthFilterAll)];
